import { render, staticRenderFns } from "./im-revoke.vue?vue&type=template&id=e10ecefe&scoped=true"
import script from "./im-revoke.vue?vue&type=script&lang=js"
export * from "./im-revoke.vue?vue&type=script&lang=js"
import style0 from "./im-revoke.vue?vue&type=style&index=0&id=e10ecefe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e10ecefe",
  null
  
)

export default component.exports